import React from 'react';
import PhoneInput from 'react-phone-input-2';
import {CountryDropdown} from 'react-country-region-selector';
import {withRouter} from 'react-router-dom';
import {User} from 'Services';
import Agenda from 'Services/Api/Admin/Agenda';

import AdminLayout from '../AdminLayout';

import {PrimaryButton, SecondaryButton} from 'Components/Button';
import {FormHandler, Input, Checkbox, Label, Select, Textarea, Toggle} from 'Components/Form';
import {Alert} from 'Components/Partials';
import {ModalTrigger} from 'Components/Modal';

import ConfirmEmail from './ConfirmEmail';

import AdminUsersApi from 'Services/Api/Admin/Users';
import AdminGroupsApi from 'Services/Api/Admin/Groups';

class UsersStore extends React.Component {

    /**
     * @var timezones
     * @type {[{label: string, value: string}, {label: string, value: string}, {label: string, value: string}]}
     */
    timezones = [
        {value: 'Group 1', label: 'Group 1'},
        {value: 'Group 1b', label: 'Group 1b'},
        {value: 'Group 2', label: 'Group 2'},
        {value: 'Group 2b', label: 'Group 2b'},
        {value: 'Group 3', label: 'Group 3'},
        {value: 'Group 3b', label: 'Group 3b'},
        {value: 'Group 4', label: 'Group 4'},
        {value: 'Group 4b', label: 'Group 4b'},
        {value: 'Group 5', label: 'Group 5'},
        {value: 'Group 5b', label: 'Group 5b'},
        {value: 'Virtual', label: 'Virtual'},
        {value: 'SPEEDO EVENTS TEAM', label: 'SPEEDO EVENTS TEAM'},
        {value: 'Evening', label: 'Evening'},
    ];

    /**
     * @var success
     * @type {string}
     */
    success = 'User ' + (this.props.match?.params?.user ? 'updated' : 'created') + ' successfully';

    /**
     * @var inputRef
     * @type {null|HTMLInputElement}
     */
    inputRef = null;

    /**
     * @method handleOpenInput
     */
    handleOpenInput = () => {
        this.inputRef.click();
    };

    /**
     * @method handleFile
     * @param {File} file
     */
    handleFile = (file) => {
        const reader = new FileReader();

        reader.onload = (e) => {
            this.setState({
                file: e.target.result,
                file_input: file,
            });
        };

        reader.readAsDataURL(file);
    };

    state = {
        user_id: this.props.match?.params?.user ?? '',
        file: false,
    };

    /**
     * @method componentDidMount
     */
    async componentDidMount() {
        if (this.state.user_id) {
            await this.loadUser();
        } else {
            this.props.setForm({
                first_name: '',
                last_name: '',
                email: '',
                password: '',
                password_confirmation: '',
                is_admin: false,
                enabled: true,
                automatically_verify_email: false,
                send_user_invite: false,
                send_password_reset_link: false,
                timezone: null
            });
        }
    }

    /**
     * @method loadUser
     */
    loadUser = async () => {
        const {user_id} = this.state;

        const response = await AdminUsersApi.get(user_id);

        this.props.setForm({
            ...response?.data.data,
        });
    }

    /**
     * @method handleSubmit
     * @param {object} form
     * @return {Promise<*>}
     */
    handleSubmit = async (form) => {
        const {user_id} = this.state;

        if (user_id) {
            return AdminUsersApi.patch(user_id, form);
        } else {
            const user = await AdminUsersApi.post(null, form);

            if (user?.success) {
                this.props.history.push(`/admin/users/store/${user?.data.data.id}`);
            } else {
                return user;
            }
        }
    };

    submit = async (e) => {
        e.preventDefault();
        const {user_id} = this.state;
        this.props.setWorking();

        if (this.state.file_input) {
            const {tempKey} = await Agenda.updateAvatar({
                file: this.state.file_input
            });

            this.props.handleInput('key', tempKey);
        }

        this.props.handleSubmit(e, this.handleSubmit, this.success, !user_id);
    }

    /**
     * @method render
     * @return {JSX.Element}
     */
    render() {
        const {user_id} = this.state;
        const {form, working, alert, getFieldError, handleInput} = this.props;
        const {file} = this.state;

        return (
            <AdminLayout>
                <div className="divide-y divide-gray-200 lg:col-span-9">
                    <div className="p-6">
                        <h2 className="text-lg leading-6 font-medium text-gray-900">
                            Admin Users - {user_id ? 'Update' : 'Create'} User
                        </h2>
                    </div>
                </div>

                <div className="m-4">
                    <form
                        className="divide-y divide-gray-200 lg:col-span-9"
                        onSubmit={(e) => this.submit(e)}
                    >
                        {alert !== null && (<Alert {...alert} />)}

                        <div className="grid grid-cols-2 gap-4 mb-4 border-0">
                            <div>
                                <Input
                                    label="First Name"
                                    value={form.first_name}
                                    id="first_name"
                                    onChange={(v) => handleInput('first_name', v)}
                                />
                            </div>

                            <div>
                                <Input
                                    label="Last Name"
                                    value={form.last_name}
                                    id="last_name"
                                    onChange={(v) => handleInput('last_name', v)}
                                />
                            </div>

                            <div>
                                <Input
                                    label="Email"
                                    value={form.email}
                                    id="email"
                                    onChange={(v) => handleInput('email', v)}
                                />
                            </div>

                            {!user_id && (form.is_admin || !window.base.using_hard_password) &&
                                <>
                                    <div>
                                        <Input
                                            label="Password"
                                            type="password"
                                            value={form.password}
                                            id="password"
                                            onChange={v => handleInput('password', v)}
                                        />
                                    </div>

                                    <div>
                                        <Input
                                            label="Password Confirmation"
                                            type="password"
                                            value={form.password_confirmation}
                                            id="password_confirmation"
                                            onChange={v => handleInput('password_confirmation', v)}
                                        />
                                    </div>
                                </>
                            }

                            <div>
                                <Select
                                    label="Group"
                                    options={this.timezones}
                                    onChange={(v) => handleInput('timezone', v)}
                                    value={form.timezone}
                                />
                            </div>

                            {!user_id &&
                                <>
                                    {window.base.features.verify_registrations &&
                                        <div className="my-auto">
                                            <Checkbox
                                                label="Automatically Verify Email"
                                                value={form.automatically_verify_email}
                                                id="automatically_verify_email"
                                                onChange={(v) => handleInput('automatically_verify_email', v.target.checked)}
                                            />
                                        </div>
                                    }
                                </>
                            }

                            {user_id && (
                                <div className="flex-col col-span-2">
                                    <div className="flex items-center mb-4">
                                        <Label label="Are you able to attend?" className="mr-16 mb-0"/>

                                        <Checkbox
                                            label="Yes"
                                            labelPlacement="right"
                                            value={form.attending}
                                            onChange={() => handleInput('attending', true)}
                                            containerClassName="mr-4"
                                        />
                                        <Checkbox
                                            label="No"
                                            labelPlacement="right"
                                            value={form.attending === false}
                                            onChange={() => handleInput('attending', false)}
                                        />
                                    </div>

                                    {form.attending && (
                                        <React.Fragment>
                                            <div className="grid md:grid-cols-2 gap-2 mb-4">
                                                <div>
                                                    <Label label="Contact Number"/>

                                                    {/*<div className="country-code-dropdown">*/}
                                                    <PhoneInput
                                                        // containerClass="rounded-full px-4 bg-white py-1 font-gilroy"
                                                        // buttonClass="border-none"
                                                        country="gb"
                                                        value={form.contact_number ?? ''}
                                                        onChange={phone => handleInput('contact_number', phone)}
                                                        enableAreaCodes={true}
                                                    />
                                                    {/*</div>*/}
                                                </div>

                                                <div>
                                                    <Label label="Country"/>

                                                    <CountryDropdown
                                                        value={form.country ?? ''}
                                                        onChange={(val) => handleInput('country', val)}
                                                        classes={'w-full'}
                                                    />
                                                </div>
                                            </div>

                                            <div className="flex items-center mb-4">
                                                <Label label="Are you a Pentland Employee?" className="mr-16 mb-0"/>

                                                <Checkbox
                                                    label="Yes"
                                                    labelPlacement="right"
                                                    value={form.pentland_employee}
                                                    onChange={() => handleInput('pentland_employee', true)}
                                                    containerClassName="mr-4"
                                                />
                                                <Checkbox
                                                    label="No"
                                                    labelPlacement="right"
                                                    value={form.pentland_employee === false}
                                                    onChange={() => handleInput('pentland_employee', false)}
                                                />
                                            </div>

                                            {form.pentland_employee === false && (
                                                <div className="grid md:grid-cols-2 gap-2 mb-4">
                                                    <div>
                                                        <Input
                                                            label="Which company do you represent?"
                                                            value={form.company}
                                                            onChange={(v) => handleInput('company', v)}
                                                        />
                                                    </div>

                                                    <div>
                                                        <Input
                                                            label="Job Title"
                                                            value={form.job_title}
                                                            onChange={(v) => handleInput('job_title', v)}
                                                        />
                                                    </div>
                                                </div>
                                            )}

                                            <div className="flex items-center mb-4">
                                                <Label
                                                    label="Is there anything we can do to assist you in your viewing experience?"
                                                    app={true} className="mr-16 mb-0"/>

                                                <Checkbox
                                                    label="Yes"
                                                    labelPlacement="right"
                                                    value={form.assistance}
                                                    onChange={() => handleInput('assistance', true)}
                                                    containerClassName="mr-4"
                                                />

                                                <Checkbox
                                                    label="No"
                                                    labelPlacement="right"
                                                    value={form.assistance === false}
                                                    onChange={() => handleInput('assistance', false)}
                                                />
                                            </div>

                                            {form.assistance && (
                                                <div className="mb-4">
                                                    <Textarea
                                                        label="Please let us know below how we can assist"
                                                        rows={6}
                                                        value={form.assistance_message}
                                                        onChange={(v) => handleInput('assistance_message', v)}
                                                    />
                                                </div>
                                            )}
                                        </React.Fragment>
                                    )}

                                    <div className="flex items-center mb-4">
                                        <Label label="Speaker" app={true} className="mr-16 mb-0"/>

                                        <Checkbox
                                            label="Yes"
                                            labelPlacement="right"
                                            value={form.is_speaker}
                                            onChange={() => handleInput('is_speaker', true)}
                                            containerClassName="mr-4"
                                        />

                                        <Checkbox
                                            label="No"
                                            labelPlacement="right"
                                            value={form.is_speaker === false}
                                            onChange={() => handleInput('is_speaker', false)}
                                        />
                                    </div>

                                    <input
                                        onChange={({target: {files}}) => {
                                            const f = files.length > 0 ? files[0] : null;
                                            this.handleFile(f);
                                        }}
                                        ref={ref => {this.inputRef = ref}}
                                        type="file" className="hidden"
                                    />

                                    {Boolean(form.is_speaker) && (
                                        <div className="flex items-center">
                                            {!file && (
                                                <div className="mt-2">
                                                    <img
                                                        src={User.getAvatarUrl(form.avatar_path_url, form.first_name)}
                                                        alt={form.first_name}
                                                        className="rounded-full h-20 w-20 object-cover"
                                                    />
                                                </div>
                                            )}

                                            {file && (
                                                <div className="mt-2">
                                                    <img
                                                        src={file}
                                                        alt={form.first_name}
                                                        className="rounded-full h-20 w-20 object-cover"
                                                    />
                                                </div>
                                            )}

                                            <SecondaryButton
                                                className="ml-2"
                                                text="Change"
                                                onClick={this.handleOpenInput}
                                            />
                                        </div>
                                    )}

                                    {Boolean(form.is_speaker) && (
                                        <div className="mb-4">
                                            <Textarea
                                                label="Speaker Bio"
                                                rows={6}
                                                value={form.speaker_bio}
                                                onChange={(v) => handleInput('speaker_bio', v)}
                                            />
                                        </div>
                                    )}

                                    {Boolean(form.is_speaker) && (
                                        <div className="mb-4">
                                            <Input
                                                label="Job Title"
                                                rows={6}
                                                value={form.job_title}
                                                onChange={(v) => handleInput('job_title', v)}
                                            />
                                        </div>
                                    )}

                                    {!form.attending && !form.is_speaker && (
                                        <div className="mb-4">
                                            <Textarea
                                                label="Please let us know why you’re unable to attend"
                                                rows={6}
                                                value={form.reason}
                                                onChange={(v) => handleInput('reason', v)}
                                            />
                                        </div>
                                    )}
                                </div>
                            )}

                            <div>
                                <Toggle
                                    label="Admin"
                                    labelPlacement="top"
                                    value={form.is_admin}
                                    id="is_admin"
                                    value={form.is_admin}
                                    onChange={(v) => handleInput('is_admin', v)}
                                />
                            </div>

                            <div>
                                <Toggle
                                    label="Enabled"
                                    labelPlacement="top"
                                    value={form.enabled}
                                    id="enabled"
                                    value={form.enabled}
                                    onChange={(v) => handleInput('enabled', v)}
                                />
                            </div>
                        </div>

                        <div className="p-6 flex justify-end">
                            {user_id && (
                                <React.Fragment>
                                    <ModalTrigger
                                        component={ConfirmEmail}
                                        props={{
                                            type: 'invite',
                                            user: {
                                                id: user_id,
                                                first_name: form.first_name,
                                                last_name: form.last_name,
                                                email: form.email,
                                            }
                                        }}
                                    >
                                        <PrimaryButton
                                            type="button"
                                            className="mr-4"
                                            text="Send Invite"
                                            working={working}
                                        />
                                    </ModalTrigger>

                                    {form.timezone && (
                                        <ModalTrigger
                                            component={ConfirmEmail}
                                            props={{
                                                type: 'confirm',
                                                user: {
                                                    id: user_id,
                                                    first_name: form.first_name,
                                                    last_name: form.last_name,
                                                    email: form.email,
                                                }
                                            }}
                                        >
                                            <PrimaryButton
                                                type="button"
                                                className="mr-4"
                                                text="Send Confirmation"
                                                working={working}
                                            />
                                        </ModalTrigger>
                                    )}
                                </React.Fragment>
                            )}

                            <PrimaryButton
                                text="Save"
                                working={working}
                            />
                        </div>
                    </form>
                </div>
            </AdminLayout>
        )
    }
}

export default withRouter(FormHandler(UsersStore));
